export default "__VITE_ASSET__za7i$8Ls__"